import { projectTypeOptions } from '../servicesData';
import { useLang } from '@/lib/LanguageContext';

export default function StepProjectDetails({ data, setData }) {
  const { t } = useLang();
  const toggleType = (type) => {
    const current = data.project_types || [];
    setData({
      ...data,
      project_types: current.includes(type) ? current.filter((t) => t !== type) : [...current, type]
    });
  };

  return (
    <div className="space-y-3">
      <div>
        <label className="text-xs font-inter font-medium tracking-[0.15em] uppercase text-muted-foreground mb-1 block">{t('Name')}</label>
        <input
          type="text"
          required
          value={data.name}
          onChange={(e) => setData({ ...data, name: e.target.value })}
          className="w-full px-4 py-2 rounded-lg bg-secondary/50 border border-border/50 text-foreground font-inter text-sm placeholder:text-muted-foreground/50 focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20 transition-all"
          placeholder={t('Your full name')} />
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-inter font-medium tracking-[0.15em] uppercase text-muted-foreground mb-1 block">{t('Email')}</label>
          <input
            type="email"
            required
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            className="w-full px-4 py-2 rounded-lg bg-secondary/50 border border-border/50 text-foreground font-inter text-sm placeholder:text-muted-foreground/50 focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20 transition-all"
            placeholder="you@email.com" />
        </div>
        <div>
          <label className="text-xs font-inter font-medium tracking-[0.15em] uppercase text-muted-foreground mb-1 block">{t('Phone Number')}</label>
          <input
            type="tel"
            required
            value={data.phone}
            onChange={(e) => setData({ ...data, phone: e.target.value })}
            className="w-full px-4 py-2 rounded-lg bg-secondary/50 border border-border/50 text-foreground font-inter text-sm placeholder:text-muted-foreground/50 focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20 transition-all"
            placeholder="+1 234 567 8900" />
        </div>
      </div>
      <div>
        <label className="text-xs font-inter font-medium tracking-[0.15em] uppercase text-muted-foreground mb-1 block">{t('Project Type')}</label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5">
          {projectTypeOptions.map((type) => {
            const active = (data.project_types || []).includes(type);
            return (
              <button
                key={type}
                type="button"
                onClick={() => toggleType(type)}
                className={`text-left px-3 py-1.5 rounded-lg border text-xs font-inter transition-all ${
                  active ? 'bg-primary/15 border-primary/50 text-primary' : 'bg-secondary/30 border-border/50 text-muted-foreground hover:border-primary/30'
                }`}>
                {t(type)}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}